import axios from "axios";
import React from "react";
import { baseUrl2 } from "../../config/clientsConfig";

const UserService = {
  getUser: (id) => {
    return axios.get(`${baseUrl2}/users/${id}`);
  },
  createUser: (userData) => {
    return axios.post(`${baseUrl2}/users/create`, userData);
  },
  fetchUsers: (body) => {
    return axios.post(`${baseUrl2}/users/list`, body);
  },
  updateUser: (id, userData) => {
    return axios.put(`${baseUrl2}/users/${id}`, userData);
  },
  getUserRoleBasedNames: (body) => {
    return axios.post(`${baseUrl2}/users/role-based` , body);
  },
  getDepartmentWithTeamMembers: (body) => {
    return axios.post(`${baseUrl2}/users/department`, body);
  },

  /// Deactivate User for GL Funnel CRM
  deactivateUser: (body) => {
    return axios.post(`${baseUrl2}/users/deactivate`, body);
  }
};
export default UserService;
